import React from 'react';
import { motion } from 'framer-motion';
import { FileDown, ShieldCheck, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[80vh] flex items-center pt-12 pb-24 overflow-hidden bg-slate-900" data-id="element-276">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-277">
        <img src="https://images.unsplash.com/photo-1501466044931-62695aada8e9?auto=format&fit=crop&q=80&w=2000" alt="Washington D.C. Capitol Landscape" className="w-full h-full object-cover opacity-50" data-id="element-278" />
        <div className="absolute inset-0 bg-gradient-to-b from-federal-blue/80 via-federal-blue/60 to-federal-blue/90" data-id="element-279" />
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10 text-center" data-id="element-280">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-281">
          <span className="inline-block px-4 py-1.5 bg-muted-gold/20 text-muted-gold text-xs font-black tracking-widest uppercase rounded-full mb-6 border border-muted-gold/30 backdrop-blur-sm" data-id="element-282">
            Federal & State Solutions
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-8 leading-[1.1] tracking-tight max-w-5xl mx-auto" data-id="element-283">
            Securing Digital Accessibility: <br data-id="element-284" />
            <span className="text-muted-gold" data-id="element-285">
              USWDS-Compliant Drupal Development & Automated Remediation.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-12 leading-relaxed font-medium" data-id="element-286">
            Empowering federal and state agencies with high-performance Drupal
            infrastructure, data-driven local SEO, and continuous WCAG
            compliance.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-287">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-muted-gold hover:bg-gold-hover text-white px-8 py-4 rounded-sm font-bold text-lg flex items-center gap-3 transition-all shadow-2xl" data-id="element-288">
              <FileDown className="w-5 h-5" data-id="element-289" />
              Download Capability Statement
            </motion.button>

            <div className="flex items-center gap-6 mt-4 sm:mt-0 px-6 py-3 bg-white/10 backdrop-blur-md rounded-full border border-white/20" data-id="element-290">
              <div className="flex items-center gap-2 text-[10px] font-bold text-white uppercase tracking-widest" data-id="element-291">
                <ShieldCheck className="w-4 h-4 text-muted-gold" data-id="element-292" />
                WCAG 2.1 AA
              </div>
              <div className="w-px h-4 bg-white/20" data-id="element-293" />
              <div className="flex items-center gap-2 text-[10px] font-bold text-white uppercase tracking-widest" data-id="element-294">
                <Zap className="w-4 h-4 text-muted-gold" data-id="element-295" />
                USWDS Ready
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}